<template>
  <div class="pageWua">
    <XR-head titleText="我的WUA" :rightShow="true"></XR-head>    
    <div class="total balance" v-if="!loaded" :style="{  backgroundImage:'url('+siteConfig.MobileBgImage+')' }">
      <p class="title">WUA总额</p>
      <p class="money">{{wuaInfo.Coin.toFixed(4)}}</p>
    </div>
    <div class="total account-address" v-if="!loaded">
      <p class="title"></p>
      <p class="address">{{wuaInfo.CoinAddress}}</p>
      <p class="copybtn">复制地址</p>
    </div>

    <div class="sub-nav" v-if="!loaded">
      <mu-list>
        <router-link to="/usercenter/wuaRecharge">
          <mu-list-item title="WUA充值">
            <mu-icon slot="left" value=":fa fa-money7"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/usercenter/wuaWithdraw">
          <mu-list-item title="WUA提现">
            <mu-icon slot="left" value=":fa fa-withdraw"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
        <mu-divider shallowInset/>
        <router-link to="/usercenter/wuaStream">
          <mu-list-item title="WUA查询">
            <mu-icon slot="left" value=":fa fa-money"/>
            <mu-icon slot="right" value=":fa fa-angle-right"/>
          </mu-list-item>
        </router-link>
      </mu-list>
    </div>
    <XR-toast ref="XRtoast"></XR-toast>
  </div>
</template>

<script>
import {ErrorCode} from '../../util/errorcode'
export default {
  data() {
    return {
      loaded : true,
      wuaInfo:{
        Coin:0
      },
      siteConfig:{ MobileBgImage : '' }
    };
  },
  mounted :function(){
    this.$refs.XRtoast.load()
    this.getSiteInfo()
    this.getWuaInfo()
  },
  methods: {
    getSiteInfo: function () {    
      const ths = this;
      this.$post('/Shop/SiteConfigServer/GetSiteConfig')
        .then(function (res) {
          if(res.IsSuccess){
            ths.siteConfig = res.Data
          }         
        })
        .catch(function (err) {
          console.log(err)
        })    
    },    
    getWuaInfo: function() {
      var ths = this;   
      ths.$post(
        "/Shop/UserServer/GetWuaAccountInfo"
      ).then(function(res) {
        if(!res.IsSuccess){          
          if(res.TypeId == 1){
            ths.$router.push("/usercenter/wuaActive")
          }
          if(res.TypeId == ErrorCode.SessionMissing){
            ths.$router.push("/Login")
          }
        }else{          
          ths.wuaInfo = res.Data;
          ths.loaded=false
          ths.$refs.XRtoast.hide()
        }
      });
    }
  }
};
</script>
<style>
.pageWua .total{
  background: white;
  padding: 20px 20px;
}
.pageWua .total.balance{
  overflow: hidden;
  background: url(/static/us-top-bg.png);
  background-size: 100% 100%;
}
.pageWua .title{
  line-height: 24px;
  font-size: 14px;
}
.pageWua .money{
  font-size: 46px;
  color:red;
  line-height: 42px;
  padding: 10px 0 10px;
  letter-spacing: -1px;
}
.pageWua .total.balance .title{
  color:white;
}
.pageWua .total.balance .money{
  color:white;
}


.pageWua .sub-nav{
  background: white;
  margin-top: 10px;
}

.pageWua .account-address .address {
  font-size:12px;
  color:black;
  background:#efefef;
  margin: 10px 0 20px;
  height:50px;
  line-height:50px;
  text-align: center;
}
.pageWua .account-address .copybtn{
  text-align: center;
  font-size: 12px;
  color:Red;
}
</style>



// WEBPACK FOOTER //
// src/pages/usercenter/wua.vue